import { render, staticRenderFns } from "./Waiter.vue?vue&type=template&id=1c1dcdc2"
import script from "./Waiter.vue?vue&type=script&lang=js"
export * from "./Waiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports